import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { ExpertProcessingStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type ExpertProcessingQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const ExpertProcessingQuizStep = ({ id, renderQuizScreen }: ExpertProcessingQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const onContinue = async () => next();

  const onBack = async () => back();

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack,
        ...(stepData as ExpertProcessingStepData),
      })}
    </>
  );
};

export default ExpertProcessingQuizStep;
